import { Directive, HostListener, Input } from '@angular/core';
import { hapticFeedback, HapticType } from '../../../core/utils/haptic-feedback.util';

/**
 * Directive to add haptic feedback to any element on click/tap.
 * Usage: <button appHapticFeedback="light">Click me</button>
 * Types: 'light' | 'medium' | 'heavy' | 'selection' | 'success' | 'warning' | 'error'
 */
@Directive({
  selector: '[appHapticFeedback]',
  standalone: true,
})
export class HapticFeedbackDirective {
  @Input() appHapticFeedback: HapticType = 'light';

  @HostListener('click')
  onClick(): void {
    hapticFeedback(this.appHapticFeedback);
  }
}